import React from "react";

import styles from "./GridHeader.module.scss";

export interface InfoBlock {
  label: string;
  content: string;
}

interface Props {
  headerTitle: string;
  infoBlocks: InfoBlock[];
}

export const GridHeader = ({ headerTitle, infoBlocks }: Props) => (
  <div className={styles.gridHeader__wrapper}>
    <h1 className={styles.gridHeader__title}>{headerTitle}</h1>

    <div className={styles.gridHeader__infoBlocks}>
      {infoBlocks.map(({ label, content }) => (
        <div key={label}>
          <h2
            className={`${styles.gridHeader__infoBlock_text}
                ${styles["gridHeader__infoBlock_text--title"]}`}
          >
            {label}
          </h2>
          <p className={styles.gridHeader__infoBlock_text}>{content}</p>
        </div>
      ))}
    </div>
    <div className={styles.gridHeader__logo} />
  </div>
);
